/**
 * Country Configuration.
 *
 * vowsera.com (global market) serves the US in USD via Stripe. vowsera.in
 * (india market) serves India in INR; Razorpay checkout arrives with market
 * phase 3. Which countries a site offers comes from utils/market.js, so the
 * header picker never shows India on vowsera.com.
 */

export const COUNTRIES = {
  US: {
    code: 'US',
    name: 'United States',
    flag: '\u{1F1FA}\u{1F1F8}',
    currency: 'USD',
    currencySymbol: '$',
    currencyName: 'US Dollar',
    dateFormat: 'MM-DD-YYYY',
    locale: 'en-US',
    paymentMethods: [
      { id: 'stripe', label: 'Pay with Stripe', desc: 'Credit/Debit Card, Apple Pay, Google Pay, Venmo', gateway: 'stripe' },
    ],
    supportedBadges: ['visa', 'mastercard', 'amex', 'apple_pay', 'google_pay', 'venmo'],
  },
  IN: {
    code: 'IN',
    name: 'India',
    flag: '\u{1F1EE}\u{1F1F3}',
    currency: 'INR',
    currencySymbol: '₹',
    currencyName: 'Indian Rupee',
    dateFormat: 'DD-MM-YYYY',
    locale: 'en-IN',
    paymentMethods: [
      { id: 'razorpay', label: 'Pay with Razorpay', desc: 'UPI, cards, net banking and wallets', gateway: 'razorpay' },
    ],
    supportedBadges: ['upi', 'rupay', 'visa', 'mastercard'],
  },
};

export const DEFAULT_COUNTRY = 'US';

export const getCountryConfig = (code) => COUNTRIES[code] || COUNTRIES[DEFAULT_COUNTRY];
